export const FIRST_ACTION_TYPE = 'FIRST_ACTION_TYPE';

export const FIRST_TIME_USER_RESET_PWD = 'FIRST_TIME_USER_RESET_PWD';



export const DEVICE_MANAGEMENT_DATA_REQUEST = 'DEVICE_MANAGEMENT_DATA_REQUEST';
export const DEVICE_MANAGEMENT_DATA_SUCCESS = 'DEVICE_MANAGEMENT_DATA_SUCCESS';
export const DEVICE_MANAGEMENT_DATA_FAILURE = 'DEVICE_MANAGEMENT_DATA_FAILURE';

export const USER_ACCESS_MENU_LINK_DATA_REQUEST = 'USER_ACCESS_MENU_LINK_DATA_REQUEST';
export const USER_ACCESS_MENU_LINK_DATA_SUCCESS = 'USER_ACCESS_MENU_LINK_DATA_SUCCESS';
export const USER_ACCESS_MENU_LINK_DATA_FAILURE = 'USER_ACCESS_MENU_LINK_DATA_FAILURE';

export const RELOAD_DETAILS_PAGE = 'RELOAD_DETAILS_PAGE';
export const DELETE_DETAILS_PAGE_DATA = 'DELETE_DETAILS_PAGE_DATA';